(function() {
    'use strict';
    
a3_cabin_reports.controller('TicketModalCtrl', TicketModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name TicketCtrl
    * @description 
    *  Report a bug of the application
    * @ngInject
    */
function TicketModalCtrl($scope, $uibModalInstance, $timeout, TicketAPIService, LogService, PhotoFactory, ticket) {
        $scope.successful = false;
        $scope.error = false;

		var q = TicketAPIService.sendTicket(ticket);

        q.then(function(responseData){
			if(responseData.data.data){
                $scope.successful = true;
			}
			else {
             $scope.error = true;
			}
            $timeout(function() {
					$uibModalInstance.close();
                }, 3000);
		},
		function(){
             $scope.error = true;
                $timeout(function() {
					$uibModalInstance.close();
                }, 3000);
		});
}
    
    
})();
    